import { AutorizationService } from 'src/app/api/autorization.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { error } from '@angular/compiler/src/util';
import { MatDialog } from '@angular/material/dialog';
import { ErrorBookComponent } from './error-book/error-book.component';
import { Component, OnInit, Input } from '@angular/core';
import { StationDetail, StationPrice, StationAvailabilities } from 'src/app/models/api_models/station';
import { StationService } from 'src/app/api/station.service';
import { ApiDate } from 'src/app/models/api_models/apiDate';
import { UserApiService } from 'src/app/user-api.service';
import { UserApi } from 'src/app/models/api_models/user';
import { BookService } from 'src/app/api/book.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-book-confirmation',
  templateUrl: './book-confirmation.component.html',
  styleUrls: ['./book-confirmation.component.scss']
})
export class BookConfirmationComponent implements OnInit {

  code_promo: string;
  response_code_promo;
  response_code_promo_price;
  checked = false;
  checkedgeolocalistion = false
  IsWait: boolean = false;
  ip_adress :any;

 

  private _isLoad: boolean = false;
  get isLoad(): boolean {
    return this._isLoad;
  }
  set isLoad(isLoad: boolean) {
    this._isLoad = isLoad;
  }

  private _availabilities: string[] = [];
  get availabilities(): string[] {
    return this._availabilities
  };
  set availabilities(availabilities: string[]) {
    this._availabilities = availabilities;
  }

  private _stationDetail: StationDetail = undefined;
  get stationDetail(): StationDetail {
    return this._stationDetail;
  }
  set stationDetail(stationDetail: StationDetail) {
    this._stationDetail = stationDetail;
  }

  private _stationPrice: StationPrice = undefined;
  get stationPrice(): StationPrice {
    return this._stationPrice;
  }
  set stationPrice(stationPrice: StationPrice) {
    this._stationPrice = stationPrice;
  }

  private _dayCount: Date[] = [];
  get dayCount(): Date[] {
    return this._dayCount;
  }
  set dayCount(dayCount: Date[]) {
    this._dayCount = dayCount;
  }

  private _hourCount: string[] = [];
  get hourCount(): string[] {
    return this._hourCount;
  }
  set hourCount(hourCount: string[]) {
    this._hourCount = hourCount;
  }


  private _canReserved = true;
  get canReserved(): boolean {
    return this._canReserved;
  }
  set canReserved(canReserved: boolean) {
    this._canReserved = canReserved;
  }

  private _departureDate: ApiDate;
  get departureDate() {
    return this._departureDate;
  }
  @Input()
  set departureDate(derpartureDate) {
    this._departureDate = derpartureDate;
  }

  private _arrivalDate: ApiDate;
  get arrivalDate() {
    return this._arrivalDate;
  }
  @Input()
  set arrivalDate(arrivalDate) {
    this._arrivalDate = arrivalDate;
  }

  private _stationAvailabilities: StationAvailabilities;
  get stationAvailabilities() {
    return this._stationAvailabilities;
  }
  @Input()
  set stationAvailabilities(stationAvailabilities) {
    this._stationAvailabilities = stationAvailabilities;
    // console.error(stationAvailabilities);

    if (this._stationAvailabilities != null) {
      this.stationService.getStationDetailFromId(this._stationAvailabilities.id).subscribe(
        response => {
          this._stationDetail = response;

          // todo  probleme de date   a revoir quand l api sera prete 
          let correctiondepart: any = new Date(this._departureDate.date.getTime())

          this.stationService.stationGetPrice(this._stationAvailabilities.id, this.getResaDuration(), correctiondepart).subscribe(
            response => {
              this._isLoad = true;
              this._stationPrice = response;
              this._availabilities = this.convertAvalabilites();
            }
          );
        }
      );
    }
  }

  getResaDuration() {
    // todo  probleme de date   a revoir quand l api sera prete
    let duration = (this._arrivalDate.date.getTime() + 3600 * 1000) - (this._departureDate.date.getTime() + 3600 * 1000);
    duration = ((duration / 1000) / 60) / 30;
    // console.log(duration);
    return duration;
  }

  convertAvalabilites() {
    let tab = [];
    let startDate = new Date(this.departureDate.getDateToApiFormat());
    startDate.setHours(0, 0, 0, 0);
    let day_start = startDate.getDay();
    this._dayCount.push(new Date(startDate));
    let endDate = new Date(this.arrivalDate.getDateToApiFormat());
    endDate.setHours(23, 59, 0, 0);
    let isWanted = false;
    while (startDate < endDate) {
      isWanted = false;
      let strClass = "  ";
      if (startDate.getMinutes() == 0) {
        if (startDate.getHours() % 2 == 0) {
          if (startDate.getHours() < 10) {
            this._hourCount.push("0" + startDate.getHours() + "h");
          } else {
            this._hourCount.push(startDate.getHours() + "h");
          }
        } else {
          this._hourCount.push("    ");
        }
      }

      if (day_start != startDate.getDay()) {
        day_start = startDate.getDay();
        this._dayCount.push(new Date(startDate));
      }

      if (startDate.getTime() == this._departureDate.date.getTime()) {
        strClass += " start ";
      }
      if (startDate.getTime() >= this._departureDate.date.getTime() && (startDate.getTime() + (1000 * 60 * 30)) <= this._arrivalDate.date.getTime()) {
        strClass += " wanted ";
        isWanted = true;
      }
      if ((startDate.getTime() + (1000 * 60 * 30)) == this._arrivalDate.date.getTime()) {
        strClass += "end";
      }

      let isStart = false;
      let isEnd = false;
      let isLock = true;
      this._stationAvailabilities.availabilities.forEach(a => {

        let dStart = new Date(a.startdate.replace("Z", ""));
        let dEnd = new Date(a.enddate.replace("Z", ""));


        if (startDate.getTime() == (dStart.getTime() - (1000 * 60 * 30))) {
          strClass += " end ";
          if (isWanted) {
            this._canReserved = false;
          }
          strClass += " reserved ";


        }
        if (startDate.getTime() >= (dStart.getTime() - (1000 * 60 * 30)) && startDate.getTime() <= dEnd.getTime()) {
          isLock = false;
        }
        if (startDate.getTime() == dEnd.getTime()) {
          strClass += " start ";
          if (isWanted) {
            this._canReserved = false;
          }

          strClass += " reserved ";
        }
      });
      if (isLock) {
        if (isWanted) {
          this._canReserved = false;
        }

        strClass += " reserved ";
      }

      tab.push(strClass);
      startDate.setTime(startDate.getTime() + 1000 * 60 * 30);
    }
    return tab;
  }

  constructor(private stationService: StationService,
    private autorizationService: AutorizationService,
    private _snackBar: MatSnackBar,
    private userService: UserApiService,
    private bookService: BookService,
    public dialog: MatDialog,
    public translate: TranslateService,
    private router: Router) { }

  private _unlog: boolean = false;
  public get unlog(): boolean {
    return this._unlog;
  }
  public set unlog(state: boolean) {
    this._unlog = state
  }


 



  ngOnInit() {
    this.getIp();
    this.userService.getCurrentUserData().subscribe(
      response => {

        if (response == undefined) {
          this.unlog = true;
        }
        else {
          this.unlog = false;
        }
      },
      error => {
        // this.unlog = true;
      }
    )
  }


  
  checkCodePromo() {

     let lang = this.translate.currentLang;

    let currentUser: UserApi;
    this.userService.getCurrentUserData().subscribe(
      response => {
        currentUser = response;
        // console.log(currentUser);
        if (currentUser != null && currentUser.id != null &&
          this._arrivalDate != null && this.departureDate != null &&
          this._stationDetail != null) {
          let dStart = new Date(this._departureDate.getDateToApiFormat());
          let dEnd = new Date(this._arrivalDate.getDateToApiFormat());
          dStart.setTime(dStart.getTime() + 2 * 60 * 60 * 1000);
          dEnd.setTime(dEnd.getTime() + 2 * 60 * 60 * 1000);

          this.bookService.checkCodePromo(this._stationDetail.id, currentUser.id, dStart, dEnd, this.code_promo, lang ).subscribe(
            response => {
              this.response_code_promo = response
              this.response_code_promo_price = response.new_price;
            })
        }
      }
    )
  }



  confirmBook() {
    let currentUser: UserApi;
    this.userService.getCurrentUserData().subscribe(
      response => {
        currentUser = response;
        // console.log(currentUser);
        if (currentUser != null && currentUser.id != null &&
          this._arrivalDate != null && this.departureDate != null &&
          this._stationDetail != null) {
          let dStart = new Date(this._departureDate.getDateToApiFormat());
          let dEnd = new Date(this._arrivalDate.getDateToApiFormat());
          dStart.setTime(dStart.getTime() + 2 * 60 * 60 * 1000);
          dEnd.setTime(dEnd.getTime() + 2 * 60 * 60 * 1000);
          this.IsWait = true;
          this.bookService.postNewBook(this._stationDetail.id, currentUser.id, dStart, dEnd, this.code_promo).subscribe(
            response => {

               console.log("reservation")
               console.log(response)
              
              if (response.data.id) {




                // this.bookService.postNewBookStat(this._stationDetail, currentUser, dStart, dEnd, this.ip_adress, location.host, window.navigator.userAgent).subscribe(
                //   response => {
      
                //      console.log("reservation")
                //      console.log(response)
                    
                  
                //   },
                //   error => {
                      
                //     console.log(error)
                //   }
                // );



                


                this.IsWait = false;
                this._snackBar.open(this.translate.instant('RESERVATION.CONFIRME.MESSAGE1'),'', {
                  duration: 4000
                });
                this.router.navigate(['/auth/reservation/' + response.data.id]);
              }
              
              if (response.data.bookingSuccess === false) {
                this.IsWait = false;
                var err = response.data.message
                this.openDialog(err)
              }
            },
            error => {
                this.IsWait = false;
                this.openDialog(this.translate.instant('RESERVATION.CONFIRME.MESSAGE2'))
            }
          );
        }
      }
    )
  }




  // confirmBookStat() {
  //   let currentUser: UserApi;
  //   this.userService.getCurrentUserData().subscribe(
  //     response => {
  //       currentUser = response;
  //        console.log(currentUser);
  //       if (currentUser != null && currentUser.id != null &&
  //         this._arrivalDate != null && this.departureDate != null &&
  //         this._stationDetail != null) {
  //         let dStart = new Date(this._departureDate.getDateToApiFormat());
  //         let dEnd = new Date(this._arrivalDate.getDateToApiFormat());
  //         dStart.setTime(dStart.getTime() + 2 * 60 * 60 * 1000);
  //         dEnd.setTime(dEnd.getTime() + 2 * 60 * 60 * 1000);
         
  //         this.bookService.postNewBookStat(this._stationDetail, currentUser, dStart, dEnd, this.ip_adress, location.host, window.navigator.userAgent).subscribe(
  //           response => {

  //              console.log("reservation")
  //              console.log(response)
              
            
  //           },
  //           error => {
                
  //             console.log(error)
  //           }
  //         );
  //       }
  //     }
  //   )
  // }


  // open  dialog 
  openDialog(message): void {
    const dialogRef = this.dialog.open(ErrorBookComponent, {
      width: '350px',
      // height: '180px',
      data: message
    });


  }


  getIp(){
    this.autorizationService.getIP().subscribe(
      data => {
  
        console.log(data)
        this.ip_adress = data
      },
      err => {
        console.log(err)
      });
  
    }



}
